import { SelectChangeEvent } from '@mui/material';
import { StyledDropDown } from 'modules/components';
import { ChangeEvent } from 'react';
import * as ds from './dataService';



export type TrendDIrectionDropDownProps<T extends object> = {
  handleChange: (e: SelectChangeEvent<unknown> | ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  name: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object>(props: TrendDIrectionDropDownProps<T>) => {
  const { data } = ds.useQuery();

  return (
    <StyledDropDown.FC
      label='Direction'
      options={data}
      value={props.name}
      onChange={(e) => props.handleChange(e)}
    />
  );
};
